import { Row } from 'reactstrap';

function HowItWorks() {
  return (
    <div>
      <Row>
        <div className='text-center'>
          <h2 className={`display-4 fw-bold font-noto-serif`}>How it Works</h2>
        </div>
      </Row>
      <Row>
        <div className='text-center'>
          <h3 className={`font-noto-serif fw-bold`}>Simple. Secure. Smart.</h3>
        </div>
      </Row>
      <Row>
        <div className='text-center'>
          <p className='font-helvetica-world'>
            BUILDE connects homeowners and contractors through a secure,
            Al-powered platform that makes every renovation smarter,
            faster, and safer for everyone involved.</p>
        </div>
      </Row>
      <Row>
        <div className='text-center'>
          <p className='font-helvetica-world'>
            <b>For homeowners. </b>
            BUILDE transforms the way you starta project simply upload a photo of your space,
            describe your vision, and our Al generates design options and a complete bill of materials.
            These suggestions are pulled from local supply stores, ensuring accurate pricing and easy sourcing.
          </p>
        </div>
      </Row>
      <Row>
        <div className='text-center'>
          <p className='font-helvetica-world'>
            <b>For contractors. </b>
            BUILDE becomes your trusted project pipeline.
            Verified homeowners post real renovation opportunities with transparent budgets and clear scopes.
            You can browse, bid, and accept projects that match your expertize.
          </p>
        </div>
      </Row>
      <Row>
        <div className='text-center'>
          <p className='font-helvetica-world'>
            Every agreement on BUILDE is protected by smart contracts on blockchain -
            meaning payments are held safely in crypto-powered escrow and only released once both sides approve the work.
            This ensures security, accountability, and peace of mind for homeowners, while guaranteeing contractors get paid for verified work.
            BUILDE's decentralized payment options support cryptocurrency transactions, giving users the flexibility
          </p>
        </div>
      </Row>
    </div>
  );
}

export default HowItWorks;
